/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled from 'styled-components';

export const ManageAudience = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-radius: 8px;
  background-color: #f8fafc;
  box-shadow: inset 0px 2px 4px 0px rgba(0, 0, 0, 0.04);
  overflow: hidden;
`;
// export const ManageAudienceButtons = styled.button`
//   gap: 8px;
//   display: flex;
//   flex-direction: row;
//   justify-content: flex-start;
//   padding: 0px;
//   padding-top: 7px;
//   padding-right: 23px;
//   padding-bottom: 7px;
//   padding-left: 23px;
//   border-width: 0px;
//   border-radius: 4px;
//   border-top-width: 1px;
//   border-right-width: 1px;
//   border-bottom-width: 1px;
//   border-left-width: 1px;
//   border-style: solid;
//   border-color: ${Palette.PrimaryGray._200};
//   box-sizing: content-box;
//   background-color: #ffffff;
//   box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.05);
//   overflow: hidden;
//   cursor: pointer;
//   &:hover {
//     box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.3);
//   }
// `;
// export const Text1 = styled.div`
//   gap: 10px;
//   display: flex;
//   flex-grow: 1;
//   flex-direction: row;
//   justify-content: flex-start;
//   align-items: flex-start;
//   padding: 2px 0px;
// `;
// export const Label7 = styled.div`
//   width: 572px;
//   flex-grow: 1;
//   color: #3a88f6;
//   font-size: 14px;
//   font-weight: 500;
//   font-family: Roboto;
//   line-height: 20px;
//   text-align: center;
// `;
export const ManageAudienceMessage = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  border-radius: 4px;
  background-color: #f8fafc;
`;
export const Info = styled.div`
  gap: 10px;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: flex-start;
  padding: 8px;
  border-radius: 4px;
`;
export const FlexRow1 = styled.div`
  gap: 8px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
`;
export const MessageInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 16px;
  background-color: #94a3b8;
`;
export const InfoText = styled.div`
  width: 16px;
  color: #ffffff;
  font-size: 12px;
  font-weight: 500;
  font-family: Roboto;
  line-height: 16px;
  text-align: center;
  text-transform: none;
`;
export const MessageText = styled.div`
  width: 580px;
  flex-grow: 1;
  color: #334155;
  font-size: 12px;
  font-family: Roboto;
  line-height: 16px;
  text-transform: none;
`;
export const ButtonsRow = styled.button`
  gap: 8px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 0px;
  padding-top: 3px;
  padding-right: 7px;
  padding-bottom: 3px;
  padding-left: 7px;
  border-width: 0px;
  border-radius: 4px;
  box-sizing: content-box;
  background-color: rgba(255, 255, 255, 0);
  overflow: hidden;
  cursor: pointer;
  &:hover {
    box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.3);
  }
`;

export const SelectedItems = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-width: 1px;
  border-radius: 4px;
  border-style: solid;
  border-color: #e2e8f0;
  background-color: #ffffff;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.05);
`;
export const SelectedItem = styled.div`
  gap: 8px;
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 8px;
`;
export const ItemName = styled.div`
  width: 415px;
  flex-grow: 1;
  color: #334155;
  font-size: 12px;
  font-family: Roboto;
  line-height: 16px;
`;
export const Text = styled.div`
  color: #94a3b8;
  text-transform: none;
  font-size: 12px;
  font-family: Roboto;
  line-height: 16px;
  white-space: nowrap;
`;
export const PartnerIcon = styled.img`
  width: 56px;
  height: 16px;
`;

export const DeleteIcon = styled.img`
  width: 12px;
  height: 12px;

  :active {
    background: ${() => Palette.Primary._300};
    border-radius: 12px;
  }
`;

export const Container = styled.div`
  padding: 16px;
  background-color: ${({ color }) => color && color};
`;

export const Label = styled.p`
  margin-left: 16px;
  line-height: 48px;
`;
